"use strict";
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
Object.defineProperty(exports, "__esModule", { value: true });
var styles = [".outter_box[_ngcontent-%COMP%] {\n  max-height: 500px; }\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi92YXIvbGliL2plbmtpbnMvd29ya3NwYWNlL01hcHNlbmRlciA0RCBSZWxlYXNlL3dlYnNpdGUvc3JjL2FwcC9tYWluL21hcC9kZXRhaWwtdmlld3MvYW5ub3RzLzNyZF9wYXJ0eS9hZ3Jvbm9tZXllLmNvbXBvbmVudC5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0ksa0JBQWdCLEVBRW5CIiwiZmlsZSI6InNyYy9hcHAvbWFpbi9tYXAvZGV0YWlsLXZpZXdzL2Fubm90cy8zcmRfcGFydHkvYWdyb25vbWV5ZS5jb21wb25lbnQuc2NzcyIsInNvdXJjZXNDb250ZW50IjpbIi5vdXR0ZXJfYm94e1xuICAgIG1heC1oZWlnaHQ6NTAwcHg7XG4gIFxufVxuIl19 */"];
exports.styles = styles;
